import '@aws-amplify/ui-react/styles.css';

import { ThemeProvider as AWSThemeProvider, Authenticator } from '@aws-amplify/ui-react';
import { faEnvelope, faKey, faSyncAlt } from '@fortawesome/free-solid-svg-icons';

// IMPORT COMPONENTS
import { AppRouter } from './routers/AppRouter';
import { Provider } from 'react-redux';
// IMPORT PACKAGES
import React from 'react';
import awsTheme from '../amplify/theme';
import components from '../amplify/components';
// IMPORT STORE
import { createAppStore } from '../components/state/stores/AppStore';
import formFields from '../amplify/formFields';
import { library } from '@fortawesome/fontawesome-svg-core';

library.add(faEnvelope, faKey, faSyncAlt);

export const store = createAppStore();

const App = () => {
    return (
        <Provider store={store}>
            <AWSThemeProvider theme={awsTheme}>
                <Authenticator formFields={formFields} components={components} hideSignUp>
                    {({ user, signOut }) => (
                        <div className="p-3">
                            <AppRouter user={user} signOut={signOut} />
                        </div>
                    )}
                </Authenticator>
            </AWSThemeProvider>
        </Provider>
    );
};
export default App;
